<template>
  <section class="link-box">
    <div class="block-foot-message">
      <img src="/static/img/recommend/lp/houen/products/linkbox_sideimg.png">
      <p>実は、この２つの暴露数の個性は、恋愛や仕事で、表に出てくる暴露数が違うんです。それぞれの状況で見てみましょう。</p>
    </div>
    <div class="block-other-appraisal">
      <a href="/products/45/0002/result">あなたの恋愛について</a>
      <a href="/products/45/0003/result">仕事について</a>
    </div>
  </section>
</template>

<script>
export default {
  name: 'LinkMenuBlock',
  props: {
    colorScheme: {
      type: Object,
      default() {
        return {}
      }
    },

  },
  computed: {
    
  },
  methods: {},
}
</script>

<style scoped lang="scss">
$title-fontfamily:'Hiragino Mincho Pro';
$main-green:#00462E;
$uranai-black: #32373f;
$houen-blue:#3A89C9;


.link-box{
    padding-bottom: 60px;
    background-size: contain;
    background-image: url(/static/img/recommend/lp/houen/products/bk_result.png);
    background-repeat-y: repeat;
  }
.block-foot-message{
  display: flex;
  padding-top: 40px;
  color: #32373f;
  img{
    width:128px;
    height: 142px;
    margin-right:16px;
    margin-bottom: 16px;
  }
  p{
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    margin-right: 20px;
  }
}
.block-other-appraisal{
  margin: 0 20px;
  border: 1px solid $uranai-black;
  a{
    padding: 20px;
    position: relative;
    text-decoration: none;
    display: block;
    border-bottom:1px solid  #dadada;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
    background:#fff;
    &:after{
      content:'';
      border-top:2px solid $houen-blue;
      border-right:2px solid $houen-blue;
      position: absolute;
      width: 10px;
      height: 10px;
      right: 30px;
      top: 43%;
      transform: rotate(45deg);
    }

  }
}

</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Products/houen/partials/LinkMenuBlock.vue